import { PermissionService } from "../../api/permission-service";
import { EOSService } from '../../api/eos-service'
import PeriodType from '../../model/PeriodType'

const initialState = () => {
    return {
        permissionList: [],
        periodType: ''
    }
}
const state = initialState()

const getters = {};

const actions = {
    async getPermission({ commit }, { auth }) {
        ////console.log(auth.token);
        return await PermissionService.getPermission(auth).then((response) => {
            ////console.log(response);
            var data = response.data
            if (data.ResponseResultType === 1) {
                //save person detail
                commit('setPermissionList', data.Values);

                //set Period Type
                let monthly = data.Values.includes(8)
                if (monthly) {
                    commit('setPeriodType', PeriodType.Monthly);
                } else {
                    commit('setPeriodType', PeriodType.Periodic);
                }
            }
            return data
        })
    },
    async GetAdminPermissionList() {
        return await EOSService.makeRequest(PermissionService.GetAdminPermissionList())
    },
    async GetPersonelPermissionList() {
        return await EOSService.makeRequest(PermissionService.GetPersonelPermissionList())
    },
    async ResetPersonsDedicatedPermission() {
        return await EOSService.makeRequest(PermissionService.ResetPersonsDedicatedPermission())
    },
    async UpdateSectionsPersonPermission(context, { payload }) {
        var data = new URLSearchParams()
        data.append('permission', payload.permission)
        data.append('perno', payload.perno)
        return await EOSService.makeRequest(PermissionService.UpdateSectionsPersonPermission(data))
    },
    async UpdatePermission(context, { updatePermissionParams }) {
        var data = new URLSearchParams()
        data.append('perno', updatePermissionParams.perno)
        data.append('permission', updatePermissionParams.permission)
        return await EOSService.makeRequest(PermissionService.UpdatePermission(data))
    },
    async UpdateDefaultPermission(context, { updateDefaultPermissionParams }) {
        var data = new URLSearchParams()
        data.append('permission', updateDefaultPermissionParams.permission)
        return await EOSService.makeRequest(PermissionService.UpdateDefaultPermission(data))
    },
    async getSectionPermissions(context, { getSectionPermissionsParams }) {
        var params = new URLSearchParams()
        var perno = context.rootState.auth.auth.username;
        params.append('sectioncode', getSectionPermissionsParams.sectioncode)
        params.append('adminperno', perno)
        return await EOSService.makeRequest(PermissionService.getSectionPermissions(params))
    },
};

const mutations = {
    setPermissionList: (state, permissionList) => (state.permissionList = permissionList),
    setPeriodType: (state, periodType) => (state.periodType = periodType),
    resetState(state) {
        Object.assign(state, initialState())
        //console.log('resetState');
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}